module.exports = __webpack_public_path__ + "assets/security-logo-horizontal-component.7f24f17e.svg";